import { environment } from '../../../environments/environment';

export abstract class ApiService {
  protected constructor() {}

  apiUrl(url: string): string {
   return  environment.apiUrl + '/' + url;
  }
}
